import { BarChart3, BookOpen, Home, Plus, type LucideIcon } from 'lucide-react';

export interface PrimaryNavigationItem {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
  central?: boolean;
}

export const primaryNavigation: PrimaryNavigationItem[] = [
  { to: '/', label: 'Início', icon: Home, end: true },
  { to: '/library', label: 'Biblioteca', icon: BookOpen },
  { to: '/books/new', label: 'Adicionar', icon: Plus, central: true },
  { to: '/statistics', label: 'Estatísticas', icon: BarChart3 },
  { to: '/reader', label: 'Leitor', icon: BookOpen }
];
